// Price tiers are absolute, not relative: they reflect how much work (and
// therefore fee) an item actually generates. Bands are applied to the midpoint
// of the item's published range. Tier 0 = no added fee (included in the base).
export const PRICE_BANDS = [15, 40, 85, 175];

export function priceTierOf(min, max) {
  const mid = ((Number(min) || 0) + (Number(max) || 0)) / 2;
  if (mid <= 0) return 0;
  for (let i = 0; i < PRICE_BANDS.length; i++) {
    if (mid <= PRICE_BANDS[i]) return i + 1;
  }
  return 5;
}

export function computeFeeTiers(items) {
  const map = {};
  items.forEach((i) => {
    map[i.id] = priceTierOf(i.min, i.max);
  });
  return map;
}
